import axios from 'axios';
import { GET_TOKENS, GET_SPECIFIC_TOKEN, EDIT_TOKEN, TOKENS_LOADING, CLEAR_TOKENS } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IToken } from '../../types/interfaces';

export const getTokens = (duration: any) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: TOKENS_LOADING
  });
  axios
    .get('/api/tokens', {...tokenConfig(getState), params: {duration}})
    .then(res =>
      dispatch({
        type: GET_TOKENS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getUserById = (id: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: TOKENS_LOADING
  });
  axios
    .get('/api/tokens/specific', {...tokenConfig(getState), params: {id}})
    .then(res =>
      dispatch({
        type: GET_SPECIFIC_TOKEN,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const editToken = (id: number, allowed: number, user_id: number, login: string, pro: number, name: string, comment: string, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/tokens/edit', {id, allowed, user_id, login, pro, name, comment}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_TOKEN,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const setTokensLoading = () => {
  return {
    type: TOKENS_LOADING
  };
};

export const clearTokens = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_TOKENS
  })
};